import { createAsyncThunk } from "@reduxjs/toolkit";
import { GlobalContractsCommandDto } from "api/pricing";
import { RootState } from "app/store";
import { selectAllValuesForAPI } from "../../pricing-values/selectors";
import { selectGlobalGuarantees } from "../selectors/guaranteeFilterSelector";
import { fetchFunnelsByGuarantees } from "./fetchFunnelsByGuaranteesThunk";

/**
 * Relance la recherche custom-global (POST /comparateurs/custom-global-contrats) avec la
 * sélection courante (garanties + variables + frais) lue depuis le store. Utilisé après une
 * modification du bien : le bien a changé côté back, on rejoue la tarification pour mettre à
 * jour prix ET éligibilité (ex. surface > max ⇒ cartouches inéligibles), sans perdre la
 * sélection de garanties de l'utilisateur.
 */
export const refetchGlobalContracts = createAsyncThunk(
  'pricing/refetchGlobalContracts',
  async (_: void, { getState, dispatch }) => {
    const state = getState() as RootState;
    const riskId = state.pricing.riskId;
    if (!riskId) return;

    const globalGuarantees = selectGlobalGuarantees(state);
    const { fees, variables } = selectAllValuesForAPI(state);

    const command: GlobalContractsCommandDto = {
      riskId,
      guarantees: [
        ...globalGuarantees.optional.map((g) => ({
          id: g.id,
          deductible: g.deductible?.value,
          ceiling: g.ceiling?.value
        })),
        ...globalGuarantees.mandatory.map((g) => ({
          id: g.id,
          deductible: g.deductible?.value,
          ceiling: g.ceiling?.value
        }))
      ],
      fees,
      variables
    };

    await dispatch(fetchFunnelsByGuarantees(command));
  }
);
